import { Link } from "react-router-dom"

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "700px", margin: "0 auto" }}>
      <h2>Santa Flyover Privacy Policy</h2>
      <p>Last updated: 22 October 2026</p>

      <h3>Game data</h3>
      <p>
        Santa Flyover does not require an account. The game saves your scores,
        coins, unlocked items, and audio settings on your device. We do not run
        a separate server for your game progress.
      </p>

      <h3>Rewarded ads</h3>
      <p>
        You can choose to watch rewarded video ads in the game. These ads use
        Google Mobile Ads. Google may process information such as your IP
        address, device or advertising identifiers, ad views and interactions,
        and diagnostic data to provide, measure, and protect ads. The game uses
        Google's consent tools to check whether ads can be requested and to
        show a consent message where required and available. You can play
        without watching a rewarded ad. For details about Google's use of
        information, see{" "}
        <a href="https://policies.google.com/technologies/partner-sites">
          Google's partner-sites policy
        </a>.
      </p>

      <h3>Support messages</h3>
      <p>
        If you send a message through this website's support form, the message
        is processed and stored by Netlify so we can handle your request. Do
        not include sensitive information in your message. See{" "}
        <a href="https://www.netlify.com/privacy/">Netlify's privacy policy</a>
        for more about its handling of data.
      </p>

      <h3>Contact</h3>
      <p>
        If you have questions about this policy, use the{" "}
        <Link to="/support">Support</Link> page.
      </p>
    </div>
  )
}

export default PrivacyPolicy
